/**
 * @since 0.1.0
 */
export var ErrorCode;
(function (ErrorCode) {
    /**
     * The user canceled the sign-in flow.
     *
     * @since 0.1.0
     */
    ErrorCode["SignInCanceled"] = "SIGN_IN_CANCELED";
})(ErrorCode || (ErrorCode = {}));
//# sourceMappingURL=definitions.js.map